import React, {useCallback, useMemo} from 'react';
import {Select, ListItem, Text, SelectValue, Layout} from '@phonectas/unifon-ui-kit';
import {ROUTES} from 'common/constants';
import {USER_ACCESS} from 'common/components/permissions/constants';
import useUserStore from 'common/stores/user';

interface DefaultRouteSelectProps {
    value: string;
    onChange: (val: string) => void;
    t: (key: string) => string;
}

const DefaultRouteSelect: React.FC<DefaultRouteSelectProps> = ({value, onChange, t}) => {
	const user = useUserStore((state) => state.user);

	// Get available routes based on user roles
	const availableRoutes = useMemo(() => {
		if (!user) return [];

		const routes = [];

		if (user.roles.some(role => USER_ACCESS.MRC.includes(role))) {
			routes.push({value: ROUTES.MRC, label: 'MRC'});
		}
		if (user.roles.some(role => USER_ACCESS.THREE_SIXTY.includes(role))) {
			routes.push({value: ROUTES.THREE_SIXTY, label: 'Unifon 360'});
		}
		if (user.roles.some(role => USER_ACCESS.BMODASHBOARD.includes(role))) {
			routes.push({value: ROUTES.BMODASHBOARD, label: 'BMO Dashboard'});
		}
		if (user.roles.some(role => USER_ACCESS.PROFILE.includes(role))) {
			routes.push({value: ROUTES.PROFILE, label: 'Profile'});
		}

		return routes;
	}, [user]);

	const handleChange = useCallback(
		(val: SelectValue, _e: React.SyntheticEvent, _name: string) => {
			onChange(typeof val === 'string' ? val : '');
		},
		[onChange]
	);

	return (
		<Layout fullWidth direction="column" gap="xs">
			<Text variant="body1" color="textSecondary">{t('Default landing page')}</Text>
			<Select
				value={value}
				onChange={handleChange}
				fullWidth
				placeholder={t('Select default route')}
			>
				{availableRoutes.map(option => (
					<ListItem
						key={option.value}
						value={option.value}
						primaryText={t(option.label)}
						selected={value === option.value}
					/>
				))}
			</Select>
		</Layout>
	);
};

export default DefaultRouteSelect;